/* @flow */
import { call, put, fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import * as actions from 'reducers/connectedBankAccountRequest';
import type { loadAction } from 'reducers/connectedBankAccountRequest';
import ConnectedBankAccount from 'entities/ConnectedBankAccount';

export function* watchLoadRequest(): Generator<?any, ?any, ?any> {
  // $FlowFixMe
  yield* takeLatest('connectedBankAccountRequest/LOAD_REQUEST', load);
}

export function* load(action: loadAction): Generator<?any, ?any, ?any> {
  try {
    const connectedBankAccount: ?ConnectedBankAccount = yield call(
      ConnectedBankAccount.getConnectedBankAccount,
      action.token,
    );

    if (connectedBankAccount) {
      yield put(actions.loadSuccess(action.token, connectedBankAccount));
    }
  } catch (e) {
    yield put(actions.loadError(action.token, e.error || e.message || 'unknow'));
  }
}

export default function* root(): Generator<?any, ?any, ?any> {
  yield [
    fork(watchLoadRequest),
  ];
}



// WEBPACK FOOTER //
// ./src/payments/sagas/connectedBankAccountRequest.js